<template>
  <div>
    <transition name="fade">
      <leave-team-popup
        v-if="teamToLeave"
        :team="teamToLeave"
        @close="reloadTeams"
      />
      <change-email-popup
        v-if="showChangeEmail"
        @close="showChangeEmail = false"
      />
      <change-password-popup
        v-if="showChangePassword"
        @close="showChangePassword = false"
        @password-changed="passwordChanged"
      />
      <delete-account-popup
        v-if="showDeleteAccount"
        @close="showDeleteAccount = false"
        @account-deleted="(payload) => accountDeleted(payload.password)"
      />
    </transition>
    <section>
      <single-setting
        id="edit-profile"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Profile.svg')"
        :title="$t('profile')"
        :description="$t('personalDataAndContact')"
      >
        <editable-input
          id="input-name-wrapper"
          v-model="userName"
          reference="name"
          auto-capitalize="words"
          :title="$t('name')"
          :incorrect-value-msg="$t('nameCannotBeEmpty')"
          restore-value-on-incorrect
          @focus-out="changeName"
        />      
        <div
          id="avatar-wrapper"
          class="file-avatar file-upload fullspan"
        >
          <img
            :src="avatarUrl"
            :style="{ backgroundColor: userColor }"
          >
          <div class="custom-upload">
            <label for="file-input">
              <div class="clavo-button clavo-button-action">
                {{ $t('changeAvatar') }}
              </div>
            </label>
            <input
              id="file-input"
              type="file"
              accept="image/*"
              @change="uploadAvatar"
            >
          </div>
        </div>
        <editable-input
          id="input-email-wrapper"
          v-model="userEmail"
          reference="email"
          :title="$t('email')"
          :description="$t('emailChange')"
          :disabled="true"
          @description-clicked="showChangeEmail = true"
        />
        <editable-input
          id="input-phone-wrapper"
          v-model="userPhone"
          reference="phone"
          :title="$t('phone')"
          :placeholder="$t('phonePlaceholder')"
          :incorrect-value-msg="$t('phoneIncorrect')"
          :validation-function="simplePhoneValid"
          @focus-out="changePhone"
        />
      </single-setting>
      <single-setting
        id="change-password"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Password.svg')"
        :title="$t('password')"
        :description="$t('changePasswordDesc')"
      >
        <!--<div class="Slot">-->
        <editable-input
          id="input-password-wrapper"
          reference="password"
          :title="$t('password')"
          value="*placeholder*"
          input-type="password"
          :disabled="true"
        />
        <button
          id="change-password-button"
          class="clavo-button secondary"
          @click="showChangePassword = true"
        >
          {{ $t('change') }}
        </button>
      </single-setting>
      <single-setting
        id="team-role"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Team.svg')"
        :title="$t('teamRoleTitle')"
        :description="$t('youAreMemberOfTeams')"
      >
        <!--<div class="Slot">-->
        <team-role-list
          id="team-list-wrapper"
          :ref="'teamRoleList'"
          @show-leave-team-popup="showLeaveTeamPopup"
        />
        <!--
                                </div>
                -->
      </single-setting>
      <single-setting
        id="delete-account"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Delete.svg')"
        :title="$t('deleteAccount')"
        :description="$t('deleteAccountDescription')"
      >
        <button
          id="delete-account-button"
          class="clavo-button clavo-button-danger-secondary"
          @click="deleteAccountPressed"
        >
          {{ $t('deleteAccount') }}
        </button>
      </single-setting>
    </section>
  </div>
</template>

<script>
import User from '@/components/User'
import Constants from '@/components/Constants'
import Validation from '@/components/Validation'
import SingleSetting from '@/components/Settings/SingleSetting'
import EditableInput from '@/components/UI/EditableInput'
import ChangeEmailPopup from '@/components/Settings/ChangeEmailPopup'
import ChangePasswordPopup from '@/components/Settings/ChangePasswordPopup'
import DeleteAccountPopup from '@/components/Settings/DeleteAccountPopup'
import TeamRoleList from '@/components/Team/TeamRoleList'
import EventBus from '@/EventBus'
import Parse from 'parse'
import LeaveTeamPopup from '@/components/Team/LeaveTeamPopup'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  components: {
    ChangePasswordPopup,
    ChangeEmailPopup,
    DeleteAccountPopup,
    SingleSetting,
    EditableInput,
    TeamRoleList,
    LeaveTeamPopup,
  },
  mixins: [User, Constants, Validation, ParseFunctions],
  data() {
    return {
      settings: null,
      settingsLoaded: false,
      showChangeEmail: false,
      showChangePassword: false,
      showDeleteAccount: false,
      showInfoBar: false,
      infoBarMsg: '',
      infoBarError: false,
      teamToLeave: undefined,
    }
  },
  computed: {
    userName: {
      get: function() {
        return Parse.User.current().get('fullName')
      },
      set: function(value) {
        // console.log('user name setter')
        Parse.User.current().set('fullName', value)
      },
    },
    userEmail: {
      get: function() {
        return Parse.User.current().get('email')
      },
      set: function(value) {
        Parse.User.current().set('email', value)
      },
    },
    userPhone: {
      get: function() {
        return Parse.User.current().get('phone')
      },
      set: function(value) {
        Parse.User.current().set('phone', value)
      },
    },
  },
  async created() {
    // console.log('Parse.User.current():', await Parse.User.current().fetch()) // PROD DEBUG 
    await this.load()
  },
  methods: {
    async load() {
      let res = await this.userSettingsCLAPI()
      if (res.status === 'ok') {
        this.settings = res.settings
        this.settingsLoaded = true
      } else {
        this.showServerError(res)
      }
    },
    async reloadTeams() {
      this.teamToLeave = undefined
      let res = await this.getTeams()
      if (res.status === 'ok') {
        this.$refs.teamRoleList.teams = res.teams
        EventBus.$emit('reload-teams')

      } else {
        this.showServerError(res)
      }
      // console.log(this.$store.state.teams)
    },
    async changeName(value) {
      if (value && value.length) {
        this.userName = value
        await Parse.User.current().save()
        await Parse.User.current().fetch()
      }
      EventBus.$emit('name-changed', value)
    },
    async changePhone(value) {
      this.userPhone = value
      await Parse.User.current().save()
      await Parse.User.current().fetch()
    },
    passwordChanged(status, error) {
      if (status === 'ok') {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('passwordChangedSuccessfully'),
        })
        this.showChangePassword = false
      } else {
        let msg
        switch (error) {
        case 'oldPasswordInvalid':
          msg = this.$t('passwordChangeInvalidOld')
          break
        case 'newPasswordInvalid':
          msg = this.$t('passwordChangeInvalidNew')
          break
        case 'unknownError':
          msg = this.$t('passwordChangeUnknownError')
          break
        default:
          msg = this.$t('unknownErrorResponse')
          break
        }
        EventBus.$emit('new-info-bar-msg', {
          msg: msg,
          error: true,
        })
      }
    },
    async accountDeleted(password) {
      this.showDeleteAccount = false
      let userId = Parse.User.current().id
      let res = await this.deleteUser(password)
      if (res.status === 'ok'){
        this.showMessage('accountDeleted')
        await this.parseLogout()
        await this.$router.push({
          path: 'account-deletion',
          query: { id: userId }
        })
      }else{
        this.showError('accountDeleteError')
      }
    },
    showLeaveTeamPopup(team) {
      if(this.$store.state.teams.length > 1){
        this.teamToLeave = team
      }
      else{
        this.showError('youCantLeaveYourLastTeam')
      }
    },
    async deleteAccountPressed() {
      if(this.$store.state.teams.length > 1){
        this.showError('youNeedToLeaveTeams')
      }else{
        let canDelete = await this.checkIfCanDeleteUser()
        if (canDelete.status === 'ok'){
          this.showDeleteAccount = true
        }else{
          this.showError('passOwnershipOrDelete')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  display: flex; // flexbox is sufficient
  flex-direction: column;
  // max-width: 550px;

  .single-setting {
    margin-bottom: 60px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  /*
    display: grid;
    grid-template-rows: auto auto auto auto;
    grid-row-gap: 60px;
    #edit-profile {
      grid-row: 1;
    }
    #change-password {
      grid-row: 2;
    }
    #team-role {
      grid-row: 3;
    }
    #delete-account {
      grid-row: 4;
    }*/

  .file-avatar {
    display: flex;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
      border-radius: 50px;
      //margin-right: 15px;
    }

    &.file-upload {
      //pointer-events: auto;
      .custom-upload {
        position: relative;
        overflow: hidden;

        input[type='file'] {
          font-size: 100px; //stupid but works
          display: none;
          left: 0;
          top: 0; // to work in firefoxe
          //display: none;
          /*
                    //opacity: 0;
                    display: none;*/ // to show cursor in chrome
          cursor: pointer;
        }

        label {
          div {
            margin-right: 15px;
            color: $blue;
            @include font-rule('averta-bold');
            font-size: 14px;
            padding: 6px 10px;
            text-align: left;
            border: 0px;
            cursor: pointer;
            &:hover {
              color: $dark-blue;
            }
          }
        }
      }
    }
  }
}

@include respond-above(sm) {
  section {
    margin: 35px;
  }
  // change password
  #input-password-wrapper {
    grid-row: 1;
    grid-column: 1;
  }

  #change-password-button {
    grid-row: 1;
    grid-column: 2;

    margin-right: 15px;
    padding: 6px 10px;
    width: 120px;
    @include font-rule('averta-bold');
    font-size: 14px;

    align-self: end;
  }

  // team roles
  #team-list-wrapper {
    // fill whole grid
    grid-column: 1 / span 3;
    //grid-row: 1 / span 2;
    width: 100%;
  }

  // delete account
  #delete-account-button {
    //grid-row: 1;
    grid-column: 1;

    width: 200px;
    @include font-rule('averta-bold');
    font-size: 16px;
  }

  #input-name-wrapper {
    grid-row: 1;
  }

  #avatar-wrapper {
    grid-row: 1;
  }

  #input-email-wrapper {
    grid-row: 2;
  }

  #input-phone-wrapper {
    grid-row: 2;
  }
  /* }*/
}

@include respond-below(sm) {
  section {
    margin: 20px;
    margin-top: 35px;
  }
  .single-setting {
    //width: 322px;
    //width: 100%;
  }
  #team-list-wrapper {
    // width: 100%;
  }

  .slot {
    display: flex;
    flex-direction: column;
    width: 100%;

    button {
      width: 100%;
      @include font-rule('averta-bold');
      font-size: 16px;
    }
  }
}
</style>
